import JourneyWithNextSchedule from '../../JourneyWithNextSchedule';
import { JourneyActionPayload, getCurrentSchedule } from '..';
import { Button as ButtonSmall } from '../style';
import Modal from '../../../pages/Journey/ContentExams/Modal';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { ISchedules } from '../../../../services/journey.service';

export const MedicalRequestAvailableSmall = ({ journey }: JourneyActionPayload) => {
  const [open, setOpen] = useState(false);
  const {
    journey: { files }
  } = useSelector((state: RootState) => state);

  const handleOpen = () => {
    setOpen(!open);
  };

  const currentSchedule = getCurrentSchedule(journey);
  return (
    <>
      <JourneyWithNextSchedule
        journey={journey}
        schedule={currentSchedule as ISchedules}
        actionButton={
          <ButtonSmall variant="contained" onClick={() => handleOpen()}>
            Ver exame
          </ButtonSmall>
        }
      />
      <Modal
        openCloseController={open}
        onCloseHandler={() => {
          handleOpen();
        }}
        infoType={'REVENUES'}
        dataFiles={files}
      />
    </>
  );
};
